var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex space-x-2.5"},[_c('v-text-field',{attrs:{"label":"Buy Quantity","type":"number","value":_vm.buyQty,"outlined":"","dense":"","hide-details":""}}),_c('v-text-field',{attrs:{"label":"Get Quantity","type":"number","value":_vm.getQty,"outlined":"","dense":"","hide-details":""},on:{"input":_vm.getQuantityChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }